import React from 'react';
import { useModal } from '@hooks';
import HowToFindServiceAccountEmail from '../components/HowToFindServiceAccountEmail';

export const useServiceAccountEmailModal = () => {
    const { open, close } = useModal();

    const showServiceAccountEmailModal = () => {
        open({
            title: (
                <span data-e2e='tracking_ga-service-account-email-modal_title'>
                    How to Grant Service Account Access
                </span>
            ),
            content: <HowToFindServiceAccountEmail close={close} />,
            settings: { maskClosable: false }
        });
    };

    return { showServiceAccountEmailModal, close };
};
